import React, { Component, Fragment, createRef } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";

import {
  addUrlsToList,
  cancelCheckUrl,
  checkUrl,
  checkUrlChange,
  clearCheckUrl,
} from "../../urlFilters.actions";
import { NotMobile, Mobile } from "../../../../hocs/Responsive";
import { UploadCsvBlock } from "../uploadCsvBlock/UploadCsvBlock";
import CheckUrlBlock from "../checkUrlBlock/CheckUrlBlock";
import { isMultipleUserLevel } from "../../../../store/account";
import { GLOBAL_URL_FILTER_ID } from "../../urlFilters.constants";
import { AllowListOverrideWarning } from "../allowListOverrideWarning";
import { isAllowListOverrideEnabled } from "../../../../store/settings/settings.selectors";
import { HelpLink } from "../../../../components/helpLink/HelpLink";

class AddUrlSection extends Component {
  constructor(props) {
    super(props);

    this.inputRef = createRef();
    this.state = {
      showUploadCsv: false,
      showActionButtons: false,
    };
  }

  componentDidUpdate(prevSProps, prevState) {
    if (prevState.showUploadCsv !== this.state.showUploadCsv) {
      this.inputRef.current && this.inputRef.current.focus();
    }
  }

  render() {
    const { showUploadCsv } = this.state;
    const {
      profileId,
      allowedTypes,
      checkUrlState,
      checkUrlChange,
      checkUrl,
      clearCheckUrl,
      cancelCheckUrl,
      addUrlsToList,
      isMultiple,
      isAllowListOverrideVisible,
    } = this.props;
    const globalConfig = profileId === GLOBAL_URL_FILTER_ID;

    return (
      <section>
        <div className={"settings-page__description"}>
          <h2>
            <FormattedMessage id={"url_check"} />
          </h2>
          {isMultiple && !globalConfig ? (
            <p>
              <FormattedMessage id={"bwlists_description"} />
            </p>
          ) : (
            <Fragment>
              <p>
                <FormattedMessage id={"bwlists_description_global"} />
              </p>
              <Mobile>
                <div className="infobar__tip">
                  <p>
                    <FormattedMessage id="url_filters_description" />
                  </p>
                  <HelpLink section={"blocking-content-by-url"}>
                    <FormattedMessage id="online_help" />
                  </HelpLink>
                </div>
              </Mobile>
            </Fragment>
          )}
        </div>
        {isAllowListOverrideVisible && <AllowListOverrideWarning />}
        <NotMobile>
          {showUploadCsv && (
            <UploadCsvBlock
              buttonRef={this.inputRef}
              toggleAddMethod={this.toggleAddMethod}
              profileId={profileId}
            />
          )}
        </NotMobile>
        {!showUploadCsv && (
          <CheckUrlBlock
            inputRef={this.inputRef}
            allowedTypes={allowedTypes}
            toggleAddMethod={this.toggleAddMethod}
            checkUrlState={checkUrlState}
            checkUrlChange={checkUrlChange}
            checkUrl={checkUrl}
            clearCheckUrl={clearCheckUrl}
            cancelCheckUrl={cancelCheckUrl}
            addUrlToList={addUrlsToList}
            profileId={profileId}
          />
        )}
      </section>
    );
  }

  toggleAddMethod = () => {
    this.setState({ showUploadCsv: !this.state.showUploadCsv });
  };
}

export default connect(
  (state) => {
    const {
      urlFilters,
      config: {
        urlFilters: { "url-types": urlTypes },
      },
    } = state;

    return {
      allowedTypes: urlTypes,
      checkUrlState: urlFilters.checkUrlState,
      isMultiple: isMultipleUserLevel(state),
      isAllowListOverrideVisible: isAllowListOverrideEnabled(state),
    };
  },
  {
    checkUrlChange,
    checkUrl,
    clearCheckUrl,
    cancelCheckUrl,
    addUrlsToList,
  }
)(AddUrlSection);
